import { types, getParent, flow, applySnapshot } from 'mobx-state-tree';

export const SurfAmount = types.model('SurfAmount', {
    //resetDate: types.string,
    initData: types.number,
    usedData: types.number,
    isCapped: types.boolean
})
    .views(self => ({
        get loggedinUser() {
            return getParent(self);
        },
        get leftData(): number {
            return self.initData - self.usedData;
        },
        get usedDataOneDecimalString(): string {
            //usedData as string with one decimal and ',' instead of '.'(ex 3.56 becomes 3,6)

            let numstr: string = '0,0';
            if (self.usedData > 0) {
                let num = Math.round( self.usedData * 10 ) / 10; //ex 3,56 becomes 3,6(36/10)
                numstr = num.toFixed(1);
                numstr.replace(/\./g, ','); //replace . with ,                
            }
            return numstr;                   
        },
        get usedDataTwoDecimalString(): string {
            //usedData as string with two decimal and ',' instead of '.'(ex 3.567 becomes 3,57)

            let numstr: string = '0,00';
            if (self.usedData > 0) {
                let num = Math.round( self.usedData * 100 ) / 100; //ex 3,567 becomes 3,57(357/100)
                numstr = num.toFixed(2);
                numstr.replace(/\./g, ','); //replace . with ,                
            }
            return numstr;                   
        },
        get usedDataAsString(): string {
            //usedData as string with ',' instead of '.'

            let numstr: string = self.usedData.toString();            
            numstr.replace(/\./g, ','); //replace . with ,                
            
            return numstr;                   
        },
    }))
    .actions(self => ({
        updateSurfAmount(data) {
            self.initData = data.initData;
            self.usedData = data.usedData;
            self.isCapped = data.isCapped;
        },

        setTest() {
            //self.resetDate = '20180224';
            self.initData = 5;
            self.usedData = 3;
            self.isCapped = false;
        },

    }));

export default SurfAmount;


// WEBPACK FOOTER //
// ./src/models/SurfAmount.ts